import { api } from 'api'

export interface SubmitForgotPasswordPayload {
  email: string
}

export const submitForgotPassword = (payload: SubmitForgotPasswordPayload): Promise<void> => {
  return api({ method: 'post', url: '/api/v1/auth/password/forgot', data: payload, headers: { withAuth: false } })
}
